import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import * as FeedfilterActions from '../../actions/FeedfilterActions'
import { Dropdown, Icon, Input } from 'semantic-ui-react'
import { Marker } from './'

const modeTranslations = {
	'is': 'ist',
	'contains': 'beinhaltet',
	'!=': 'ist nicht',
	'startsWith': 'beginnt mit',
	'endsWith': 'endet auf',
	'<': 'ist kleiner als',
	'<=': 'ist kleiner oder gleich',
	'>': 'ist größer als',
	'>=': 'ist größer oder gleich'
};

const ruleOptions = [
	{
		text: 'NevId',
		value: '$.NevId'
	},
	{
		text: 'ID',
		value: '$.ID'
	},
	{
		text: 'Descr',
		value: '$.Descr'
	},
	{
		text: 'Date',
		value: '$.Date'
	},
	{
		text: 'EventType',
		value: '$.EventType'
	},
	{
		text: 'StartDate',
		value: '$.StartDate'
	},
	{
		text: 'Priority',
		value: '$.Priority'
	},
	{
		text: 'EventStatus',
		value: '$.EventStatus'
	},
	{
		text: 'Country',
		value: '$.Country'
	},
	{
		text: 'League',
		value: '$.League'
	},
	{
		text: 'LeagueFullDescr',
		value: '$.LeagueFullDescr'
	},
	{
		text: 'PlayIndex',
		value: '$.PlayIndex'
	},
	{
		text: 'SE',
		value: '$.SE'
	},
	{
		text: 'DrawNumber',
		value: 'root.DrawNumber'
	},
	{
		text: 'Oddset.de SportId',
		value: 'location.sport'
	},
	{
		text: 'Oddset.de CountryId',
		value: 'location.country'
	},
	{
		text: 'Oddset.de TournamentId',
		value: 'location.tournament'
	},
	{
		text: 'Team',
		value: 'teams.name'
	},
	{
		text: 'Im Intralot Feed enthalten',
		value: 'root.in_feed'
	},
	{
		text: 'UID Sport',
		value: 'uid.sport'
	},
	{
		text: 'UID Category',
		value: 'uid.category'
	},
	{
		text: 'UID Tournament',
		value: 'uid.tournament'
	}
];

const outcomesOptions = [
	{
		text: 'ID',
		value: 'outcomes.ID'
	},
	{
		text: 'Market',
		value: 'outcomes.Market'
	},
	{
		text: 'Descr',
		value: 'outcomes.Descr'
	},
	{
		text: 'Odd',
		value: 'outcomes.Odd'
	},
	{
		text: 'Date',
		value: 'outcomes.Date'
	},
	{
		text: 'StartDate',
		value: 'outcomes.StartDate'
	},
	{
		text: 'SE',
		value: 'outcomes.SE'
	},
	{
		text: 'SpecialStateStatus',
		value: 'outcomes.SpecialStateStatus'
	}
];

const modeOptions = [
	{
		text: 'ist',
		value: 'is'
	},
	{
		text: 'beinhaltet',
		value: 'contains'
	},
	{
		text: 'ist nicht',
		value: '!='
	},
	{
		text: 'beginnt mit',
		value: 'startsWith'
	},
	{
		text: 'endet auf',
		value: 'endsWith'
	},
	{
		text: 'ist kleiner als',
		value: '<'
	},
	{
		text: 'ist kleiner oder gleich',
		value: '<='
	},
	{
		text: 'ist größer als',
		value: '>'
	},
	{
		text: 'ist größer oder gleich',
		value: '>='
	}
];

export function Rule(props){
    const dispatch = useDispatch();

    const translateMode = (mode) => {
		if(typeof modeTranslations[mode] !== 'undefined')
			return modeTranslations[mode];
		else
			return mode;
	}
	
	const handleValueChange = (idx, value) => {
		let values = props.condition.values.slice(0);
		values[idx] = value;
		
		//Leere Werte am Ende entfernen
		do{
			if(values[values.length - 1] === '')
				values = values.slice(0, values.length - 1);
			else
				break;
		}while(values.length > 0);
		
		dispatch(FeedfilterActions.update_rule(props.path, {values: values}));
	}

    let values = props.condition.values.slice(0);
	values.push('');
		
    return (
        <li>
            <div style={{display: 'flex'}}>
                {
                    props.marker?
                        <Marker marker={props.marker} />
                    :null
                }
                <Dropdown scrolling upward onChange={(e, {value}) => dispatch(FeedfilterActions.update_rule(props.path, {scope: value.split('.')[0], key: value.split('.')[1]}))} inline options={(props.scope === 'outcomes')?outcomesOptions:ruleOptions} value={props.condition.scope + '.' + props.condition.key} />
                <Dropdown scrolling upward onChange={(e, {value}) => dispatch(FeedfilterActions.update_rule(props.path, {mode: value}))} inline options={modeOptions} value={props.condition.mode} />
                <div>
                    {values.map((value, index) => {
                        return (
                            <div key={index}>
                                <Input key={index} size='mini' placeholder={(index === 0)?'Bitte Wert eintragen':'weiterer Wert (optional)'} value={value} onChange={(e, {value}) => handleValueChange(index, value)}/>
                            </div>
                        )

                    })}
                </div>
                <a onClick={(e) => dispatch(FeedfilterActions.remove_node(props.path))} style={{
                    color: '#FF0000',
                    marginLeft: '20px',
                    display: 'inline-block'
                }}><Icon name="remove" /></a>
            </div>
        </li>
    )


}
		